export const fullOpenIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#000000"><path d="M0 11.156v8.622h8.889l-3.656-3.546L16.344 5.454 20 9V.378h-8.889l3.656 3.546L3.656 14.701z"/></svg>`,
  name: 'full-open',
};
